import { FormError } from "modules/common/hooks/useForm";
import { ArrayItemError, isArrayItemError } from "modules/common/utils/formValidators";
import { ReactNode } from "react";

interface ErrorMessageProps {
    error: ReactNode;
    className?: string;
}

export const ErrorMessage = ({ error, className }: ErrorMessageProps) => {
    const classes = ["error-message"];
    if (className) classes.push(className);
    const classList = classes.join(" ");
    return <small className={classList}>{error}</small>;
};

interface PropertyError {
    error: FormError | FormError[];
    rowIndex: number;
}

interface FormErrorProps {
    error?: FormError | FormError[];
    propertyName?: string;
    rowIndex?: number;
}
export const FormErrorDisplay = ({ error, propertyName, rowIndex }: FormErrorProps) => {
    if (!error) return null;

    if (typeof error === "string") return <ErrorMessage error={error} />;

    if (Array.isArray(error)) {
        if (rowIndex == undefined && propertyName == undefined) return null;

        if (rowIndex !== undefined) {
            let errorsForProperty: PropertyError[] = [];
            error
                .map(e => e as ArrayItemError)
                .forEach(
                    e =>
                        (errorsForProperty = [
                            ...errorsForProperty,
                            ...e.properties
                                .filter(prop => prop.property === propertyName)
                                .map(
                                    ({ error, rowIndex }) => ({ error, rowIndex } as PropertyError)
                                ),
                        ])
                );
            if (!errorsForProperty.length) return null;

            const errorForRow = errorsForProperty.find(
                propertyError => propertyError.rowIndex === rowIndex
            );
            if (!errorForRow) return null;

            return <FormErrorDisplay error={errorForRow.error} />;
        }

        return (
            <div className="f g-24">
                {error.map((e, index) => (
                    <FormErrorDisplay key={index} error={e} />
                ))}
            </div>
        );
    }

    if (isArrayItemError(error)) {
        const errorProperty = error.properties.find(prop => prop.property === propertyName);
        return errorProperty ? <FormErrorDisplay error={errorProperty.error} /> : null;
    }

    return null;
};
